import React, { useContext, useEffect, useMemo, useState } from "react";
import Style from "./index.module.scss";
import {
    Alert,
    Input,
    InputNumber,
    message,
    Modal,
    Select,
    Spin,
    Switch
} from "antd";
import { ModalProps } from "antd/es/modal";
import lodash from "lodash";
import {
    getGroupPersonNumber,
    previewOrExecuteRandomGroup,
    queryCurrentWeektimeSign
} from "../../../../../../../../../service/group";
import Form, { useForm, useWatch } from "rc-field-form";
import useRequestFn from "../../../../../../../../../utils/useRequestFn";
import { errorMessage } from "../../../../../../../../../service/service";
import LabelRow from "../../../LabelRow";
import FieldWithError from "../../../../../../../../../components/FieldWithError";
import style from "./index.module.scss";
import { CourseContext } from "../../../../../../../Store";
import useRequest from "../../../../../../../../../utils/useRequest";
import { getStudentsByWeekTimeId } from "../../../../../../../../../service/rollCall";

interface Props extends ModalProps {
    onSuccess: (randomGroupKey: string, signInId: number) => void;
}

export interface DoRandomProps {
    signInId: number;
    groupBySign: boolean;
    groupCount: number;
    groupName?: string;
}
export default function Index({ onSuccess, ...restProps }: Props) {
    const { course } = useContext(CourseContext);
    const [num, setNum] = useState("0"); //人数
    const [form] = useForm();

    const groupBySign = useWatch("groupBySign", form);
    const signInId = useWatch("signInId", form);
    const groupCount = useWatch("groupCount", form);

    const [stuList] = useRequest(
        () => getStudentsByWeekTimeId(course.weekTimeId),
        {},
        [course]
    );

    const [signList, { loading: singListLoading }] = useRequest(
        () => queryCurrentWeektimeSign(course.weekTimeId),
        {},
        [course]
    );

    const allPersonNum = useMemo(() => {
        if (groupBySign) {
            return lodash.find(signList, { id: signInId })?.signInStuCount || 0;
        } else {
            return stuList?.length;
        }
    }, [signInId, stuList, signList, groupBySign]);

    useEffect(() => {
        setNum(getGroupPersonNumber(groupCount, allPersonNum));
    }, [groupCount]);

    function signChange() {
        form.setFieldValue("groupCount", 0);
    }

    const [saveAction, { loading: saveLoading }] = useRequestFn(
        previewOrExecuteRandomGroup
    );
    async function onFinish(data: DoRandomProps) {
        try {
            const baseParams = {
                courseNo: course.courseNo,
                courseSeq: course.courseSeq,
                weektimeId: course.weekTimeId
            };
            const parmas = lodash.cloneDeep(data);
            const { randomGroupKey, signInId } = await saveAction({
                ...parmas,
                ...baseParams
            });
            onSuccess(randomGroupKey, signInId);
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    return (
        <Modal
            title="生成随机分组"
            maskClosable={false}
            width={800}
            onOk={form.submit}
            okButtonProps={{ loading: saveLoading }}
            {...restProps}
            className={Style.root}>
            <Spin spinning={saveLoading}>
                <Form form={form} onFinish={onFinish}>
                    <LabelRow text="按照签到人数分组">
                        <FieldWithError
                            preserve={false}
                            name="groupBySign"
                            initialValue>
                            {({ value, onChange }) => (
                                <Switch
                                    checked={value}
                                    onChange={e => {
                                        onChange(e);
                                        signChange();
                                    }}
                                />
                            )}
                        </FieldWithError>
                    </LabelRow>

                    {groupBySign && (
                        <LabelRow text="选择签到" required>
                            <FieldWithError
                                rules={[
                                    {
                                        required: true,
                                        message: "请选择签到"
                                    }
                                ]}
                                preserve={false}
                                name="signInId">
                                <Select
                                    onChange={signChange}
                                    placeholder="请选择签到"
                                    loading={singListLoading}>
                                    {signList?.map(item => {
                                        return (
                                            <Select.Option
                                                value={item.id}
                                                key={item.id}>
                                                {item.title}
                                            </Select.Option>
                                        );
                                    })}
                                </Select>
                            </FieldWithError>
                        </LabelRow>
                    )}

                    <LabelRow text="分组名称">
                        <FieldWithError preserve={false} name="groupName">
                            <Input placeholder="不输入则自动生成名称" />
                        </FieldWithError>
                    </LabelRow>

                    <LabelRow text="分组个数" required colSpan={[9, 12]}>
                        <div className={style.gap}>
                            <FieldWithError
                                name="groupCount"
                                preserve={false}
                                rules={[
                                    {
                                        required: true,
                                        message: "请输入分组个数"
                                    }
                                ]}>
                                <InputNumber
                                    min={0}
                                    max={allPersonNum}
                                    placeholder="请输入"
                                    style={{ width: 110 }}
                                />
                            </FieldWithError>
                            <span>
                                分组总人数 {allPersonNum} 人，每组 {num} 人
                            </span>
                        </div>
                    </LabelRow>
                    <Alert
                        className={style.alert}
                        message={
                            <div>
                                1、每学期可进行多次随机分组，分组完全随机，可使用不同的随机分组开展小组活动。
                                <br />
                                2、使用随机分组，系统将自动为每组设置组长，教师可在预览分组中调整小组成员及组长
                                <br />
                                3、随机分组默认按选课人数分组，可选择按本节课签到人数分组。按本节签到人数分组需本节签到活动已结束。分组后签到人数不可调整。
                                <br />
                                4、按签到人数分组时，未签到同学此次不参与分组，此次小组活动成绩为0分。
                            </div>
                        }
                    />
                </Form>
            </Spin>
        </Modal>
    );
}
